/**
 * This component wraps a popper around a given element of the show-condition is met.
 * This way, it can be flexibly reused for arbitrarily many other components as well.
 */

import React from 'react'
import 'react-popper-tooltip/dist/styles.css';
import {usePopperTooltip} from "react-popper-tooltip";
import {useTheme} from "@mui/styles";

const BasicHint = ({element, hintText, options}) => {

    const theme = useTheme()

    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible
    } = usePopperTooltip(options)

    return <div>
        {/* Actual element to be rendered - refers to the tooltip to be shown */}
        <div ref={setTriggerRef}>
            {element}
        </div>

        {/* The tooltip belonging to the given element above */}
        {visible && <div ref={setTooltipRef}
                         {...getTooltipProps({
                             className: 'tooltip-container',
                             style: {backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary}
                         })}>
            {hintText}
            <div {...getArrowProps({className: 'tooltip-arrow'})}/>
        </div>}
    </div>
}

export default BasicHint
